import * as React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import { version } from '../package.json';

import config from './config';

const bugsnagClient = Bugsnag.start({
  apiKey: '3d238e566fb94ab06e944e597b161a38',
  appVersion: version,
  plugins: [new BugsnagPluginReact()],
  releaseStage: config.IS_STAGING ? 'staging' : 'production'
});
const ErrorBoundary = bugsnagClient.getPlugin('react').createErrorBoundary(React);

export default {
  bugsnagClient,
  ErrorBoundary
};
